import "./preloadPolyfills"
import "legacy"
import "reactLoader"

import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import SessionExpiryAlertBootstrap from "SessionExpiry/AlertBootstrap"

const root = document.querySelector("#sessionExpiry")
if (root) {
  createRoot(root).render(
    <StrictMode>
      <SessionExpiryAlertBootstrap userId={window.currentUserId} />
    </StrictMode>
  )
}
